import { render, staticRenderFns } from "./surveyRegistration.vue?vue&type=template&id=49c0cacd&"
import script from "./surveyRegistration.vue?vue&type=script&lang=js&"
export * from "./surveyRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('49c0cacd', component.options)
    } else {
      api.reload('49c0cacd', component.options)
    }
    module.hot.accept("./surveyRegistration.vue?vue&type=template&id=49c0cacd&", function () {
      api.rerender('49c0cacd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/UserProfile/Scripts/Survey/surveyRegistration.vue"
export default component.exports